// Small DOM helpers shared across the input + shortcut layers.

// Is the user currently typing into a text field? Gameplay keybinds and dev shortcuts must NOT fire while a
// username box, rename input, search box or chat has focus -- otherwise pressing 'p' opens the perf panel
// mid-word, and a bound movement key ('d') gets eaten by the keybind's preventDefault so it can't even be
// typed. Checks the ACTIVE element (focus), so it is reliable no matter which listener sees the event.
export function typingInField(): boolean {
  const el = document.activeElement as HTMLElement | null;
  if (!el) return false;
  const tag = el.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable;
}
